import React, { useEffect, useState } from "react";
import "./index.scss";
import { SuccessLogo, SuccessLogoSM } from "../../assets/images/svg/svg";
import {
  buyNow,
  orders,
  ordersDetails,
  orderSummary,
  paymentSummary,
} from "../../utils/router/constant";
import Button from "../common/button";
import { useLocation, useNavigate } from "react-router-dom";
import MainLayout from "../../layout/mainLayout";
import {
  formatDate,
  formatDateTime,
  formatPaymentMode,
  getParamsFromURL,
  setParamsInURL,
} from "../../utils/helper";
import { readData } from "../../service/order/orderService";
import { useSelector } from "react-redux";
import { createForm, updateForm } from "../../service/proposal/proposalService";

const Success = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [orderId, setOrderId] = useState(null);
  const nav = useNavigate();
  const [entityid, setEntityId] = useState(null);
  const detailsData = useSelector(
    (state) => state.orders.selectedOrder.detailsData
  );

  console.log("detailsData", detailsData)
  const productAttributes = useSelector(
    (state) => state.product.productAttributes
  );

  const data = useSelector((state) => state.orders.selectedOrder.detailsData);
  const productType = data.product_type_name;

  // Set when /payment-processing hands us the polled PaymentData directly,
  // instead of the legacy encrypted `code` param.
  const routeState = location.state;

  useEffect(() => {
    if (routeState) return;

    const fetchCode = async () => {
      await getParamsFromURL(location).then((params) => {
        if (params) {
          setOrderId(params["orderId"]);
          setEntityId(params["entityid"]);
        } else {
          console.error("No parameters found");
        }
      });
    };
    fetchCode();
  }, [location, routeState]);

  useEffect(() => {
    if (orderId) {
      readData(orderId, "ODR");
    }
  }, [orderId]);

  useEffect(() => {
    if (orderId && detailsData && detailsData?.renewal_status) {
      const entity = {
        status: detailsData.status,
        variant_json: detailsData.current_variant_json,
      };
    }
  }, [orderId, detailsData]);

  const parsedResponse = JSON.parse(
    detailsData?.payment_data?.payment_response || "{}"
  );

  const paymentTime = parsedResponse?.data?.payment?.payment_time ?? 
                      parsedResponse?.payment_time ?? 
                      parsedResponse?.payment_completion_time ??
                      detailsData?.payment_data?.payment_date;

  const paymentResponse = {
    cf_payment_id: parsedResponse?.data?.payment?.cf_payment_id ?? 
                   parsedResponse?.cf_payment_id ?? 
                   detailsData?.payment_data?.txn_id,
    order_id: parsedResponse?.data?.order?.order_id ?? 
              parsedResponse?.order_id ?? 
              detailsData?.payment_data?.order_id,
    payment_amount: parsedResponse?.data?.payment?.payment_amount ?? 
                    parsedResponse?.payment_amount ?? 
                    detailsData?.payment_data?.amount,
    payment_group: parsedResponse?.data?.payment?.payment_group ?? 
                   parsedResponse?.payment_group ?? 
                   detailsData?.payment_data?.mode,
    payment_time: paymentTime,
    payment_status: parsedResponse?.data?.payment?.payment_status ?? 
                    parsedResponse?.payment_status ?? 
                    detailsData?.payment_data?.payment_status,
    bank_reference: parsedResponse?.data?.payment?.bank_reference ?? 
                    parsedResponse?.bank_reference ?? 
                    detailsData?.payment_data?.bank_rrn,
  };

  // Arriving from /payment-processing there is no `code` param and no order in
  // the store, so render from the PaymentData the status poll returned.
  const payment = routeState
    ? {
        cf_payment_id: routeState.txnId,
        order_id: routeState.orderId,
        payment_amount: routeState.amount,
        payment_group: routeState.mode,
        payment_time: routeState.paymentDate,
        payment_status: routeState.paymentStatus,
        bank_reference: routeState.bankRrn,
      }
    : paymentResponse;

  const renderInfoBlock = (label, value) => (
    <div className="info-block">
      <div className="label">{label}</div>
      <div className="value">{value || "N/A"}</div>
    </div>
  );

  // const handleContinue = async () => {
  //   const paramObject = {
  //     entityid: entityid,
  //     orderId: orderId,
  //   };

  //   const params = await setParamsInURL(location, paramObject);
  //   if (productType === "UMBRELLA") {
  //     navigate(`${buyNow}?${params}`);
  //   } else {
  //     navigate(`${ordersDetails}?${params}`);
  //   }
  // };

  const handleContinue = async () => {
    // The status poll carries no PspOrder entity id, so there is no order
    // detail page to deep-link into. Send them to the list instead.
    if (!orderId) {
      navigate(orders);
      return;
    }

    const paramObject = {
      entityid: entityid,
      orderId: orderId,
    };

    const params = await setParamsInURL(location, paramObject);

    if (detailsData?.payment_data?.return_url) {
      window.location.href = `${detailsData?.payment_data?.return_url}?${params}`;
    } else {
      navigate(`${ordersDetails}?${params}`);
    }
  };

  return (
    <div className="status-layout-container">
      <MainLayout>
        <div className="status--container">
          <div className="status--main">
            {/* <div className="status--image success--bg">
            <SuccessLogo />
          </div> */}
            <SuccessLogoSM />
            <div className="status--content">
              <h1 className="status--title success--title">Yay!</h1>
              <h4 className="status--subtitle">Payment successful!</h4>
              <h4 className="status--subtitle">
                Order ID: {detailsData.code || payment.order_id}
              </h4>
              <h4 className="status--subtitle">
                Your acknowledgement is valuable to us!
              </h4>
            </div>
            <div className="payment-info-container mt-4">
              {renderInfoBlock("Transaction ID", payment.cf_payment_id)}
              {renderInfoBlock("Order ID", payment.order_id)}
              {renderInfoBlock(
                "Amount",
                payment.payment_amount != null
                  ? `₹${payment.payment_amount}`
                  : null
              )}
              {renderInfoBlock("Payment Mode", formatPaymentMode(payment.payment_group))}
              {renderInfoBlock("Bank RRN", payment.bank_reference)}
              {renderInfoBlock("Date", formatDate(payment.payment_time))}
              {renderInfoBlock("Status", payment.payment_status)}
            </div>
            <div className="status--footer">
              <Button
                type="button"
                variant="primary"
                label="Continue"
                className={"btn-primary-width"}
                onClick={() => handleContinue()}
              />
            </div>
          </div>
        </div>
      </MainLayout>
    </div>
  );
};

export default Success;
